import { useJobFilterProperties } from '@/components/jobs/job-search-page/useJobFilterProperties'
import { useGetters, useState } from 'vuex-composition-helpers'
import { computed } from 'vue'
import { useBatchFilterProperties } from '@/components/batches/useBatchFilterProperties'
import { FiltersTopBarEntity } from '@/components/filters/useFilterContextBridge'
import { useGetSelectableHubs } from '@/api/hubs'

export function useFilterProperties(entityType: FiltersTopBarEntity) {
  if (entityType === 'Job') {
    const { getOrganizationId, getAccessibleHubIds, isGlobalAdmin } = useGetters('permissions', [
      'getOrganizationId',
      'getAccessibleHubIds',
      'isGlobalAdmin',
    ])
    const { getAllHubs: getHubs } = useGetters('businessUnits', ['getAllHubs'])
    const { all: getTasks } = useState('tasks', ['all'])
    const { jobCustomFieldsSchema: getJobSchemas } = useState('schemas', ['jobCustomFieldsSchema'])
    const { data: selectableHubs } = useGetSelectableHubs()
    const getDirectHubIds = computed(() => selectableHubs.value?.map((hub) => hub.id) ?? [])

    const autocompleteMenuMaxHeight = computed(() => `${Math.min(800, 0.8 * window.innerHeight)}px`)

    const { basicFilterableProperties, customFilterableProperties } = useJobFilterProperties(
      getTasks,
      getJobSchemas,
      getAccessibleHubIds,
      isGlobalAdmin,
      getOrganizationId,
      getHubs,
      getDirectHubIds,
    )

    return { basicFilterableProperties, customFilterableProperties }
  } else {
    const { basicFilterableProperties, customFilterableProperties } = useBatchFilterProperties()
    return { basicFilterableProperties, customFilterableProperties }
  }
}
